import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgEquitation(props) {
    return (
        <Svg
            width={props.size ?? 20}
            height={props.size ?? 20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <G clipPath="url(#clip0_196_12878)" fill={props.color ? props.color : baseColors.green.primary}>
                <Path d="M14.72 12.192l.93-2.117a2.781 2.781 0 01-.504-.073c-.971-.244-1.697-1.008-2.201-1.832h-.96c.123.425.053.88-.19 1.249l-1.901 2.9a1.515 1.515 0 01-2.103.435 1.52 1.52 0 01-.436-2.101l.935-1.426-1.077-.497a1.504 1.504 0 01-.64-.56h-.63a2.63 2.63 0 00-1.717.647C3.579 8.372 1.2 6.953.43 9.57c-.806 2.738 1.048 3.204-.36 4.444a.208.208 0 00.204.354c.668-.226 1.563-.926 1.884-3.01.216-1.407.91-1.901 1.498-1.857-.226.39-.365.837-.365 1.32 0 .731.295 1.393.773 1.872l-1.013 1.55-.054.081a.677.677 0 00-.11.408l.244 4.433a.491.491 0 00.972.06l.488-2.66.781 2.71a.491.491 0 00.96-.159l-.177-3.969 1.155-1.673h3.73l.772 1.543-.624 4.043a.526.526 0 001.01.27l1.282-3.32.636 3.248a.502.502 0 00.994-.125l-.391-6.941zM10.656 2.862a1.264 1.264 0 10-.001-2.527 1.264 1.264 0 00.001 2.527z" />
                <Path d="M19.674 5.65l-2.305-1.933.197-1.825a.187.187 0 00-.316-.156l-1.058 1.012-.753 1.686-1.194 1.792c.343.865.841 1.68 1.394 1.817.282.07.636-.04 1.036-.299l.451-1.026 1.14.51c-1.064 1.171-2.005 1.668-2.791 1.468-1.196-.299-1.922-2.201-2.2-3.27a.551.551 0 00-.001-.348.563.563 0 00-.723-.336l-1.485.542-.502-1.108v-.002a.946.946 0 00-.561-1.225l-.105-.038a.947.947 0 00-1.187.505c-.363.813-.965 2.15-1.63 3.582a.845.845 0 00.414 1.12l1.786.824-1.363 2.08a.845.845 0 101.413.926l1.902-2.899c.135-.205.342-.912-.31-1.209-.424-.193-1.476-.683-1.476-.683l.556-1.486c.278.613.37.88.705.88.319 0 .866-.245 1.999-.665.32 1.095 1.097 3.085 2.603 3.463.167.041.336.062.508.062.963 0 2.015-.659 3.135-1.949.125.006.25-.01.37-.056a.913.913 0 00.508-.482l.09-.2a.915.915 0 00-.247-1.074z" />
            </G>
            <Defs>
                <ClipPath id="clip0_196_12878">
                    <Path fill="#fff" d="M0 0H20V20H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgEquitation
